import { ChoosePlanProduct } from "./choose-plan-product";

export class ChoosePlan {
    
	factoryTimeLimit: number;
	factoryDistanceLimit: number;
	extensionList: ChoosePlanProduct[] = []
	maintenanceList: ChoosePlanProduct[] = []
	partList: ChoosePlanProduct[] = []

	constructor() {
		
	}
}
